module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/event-3-5fd5a212ab2a27cb14505c913f426761.jpg";